import { AddToBasket } from 'components/buttons/add-to-basket';
import { Button } from 'components/buttons/button';
import { Spinner } from 'components/spinner';
import { GetEventQueryResult } from 'lib/graphql-generated';
import { useGetRemainingTickets } from 'lib/hooks/use-get-remaining-tickets';
import { useUser } from 'lib/hooks/use-user';
import { TicketContainer } from './ticket-container';

interface Props {
  event: GetEventQueryResult['data']['events'][0];
}
export const BookClubTicketSection = ({ event }: Props) => {
  const { userData } = useUser();
  const { isError, isLoading, ticketData } = useGetRemainingTickets(event.id, {
    refreshInterval: 30000,
  });

  return (
    <>
      <section
        className={`col-span-full mt-8 bg-blue-light text-black pt-6 pb-8 md:px-12`}>
        <h2 className='header text-lg text-center mb-2 '>Book Now</h2>

        {isLoading ? (
          <div className='w-full text-center flex flex-row space-x-4 justify-center'>
            <p>Getting Event Ticket Data </p>
            <Spinner />
          </div>
        ) : !!isError ? (
          <div className='w-full text-center flex flex-row space-x-4 justify-center text-red-800'>
            <p>
              There was an error fetching ticketing data. If this problem
              persists please contact us directly!
            </p>
          </div>
        ) : (
          <article className='bg-opacity-40 bg-white overflow-hidden rounded-lg'>
            <TicketContainer
              header='Reserve Free Seat'
              text={`Buy the book below and use your book club discount!`}
              button={
                ticketData.remaningFreeSeats <= 0 ? (
                  <span className='my-auto ml-auto mr-auto md:mr-0 bg-yellow-light px-4 rounded-md text-yellow-900'>
                    Sold out
                  </span>
                ) : !!userData?.accountId ? (
                  <AddToBasket
                    className='whitespace-nowrap my-auto ml-auto mr-auto md:mr-0'
                    buttonType='secondary'
                    buttonSize='sm'
                    payload={{
                      type: 'ticket-free',
                      id: `ticket-free-${event.id}`,
                      data: {
                        quantity: 1,
                        event: {
                          event_id: event.id,
                          title: event.title,
                          image: event.image,
                        },
                      },
                    }}>
                    Add to Basket
                  </AddToBasket>
                ) : (
                  <Button
                    buttonType='secondary'
                    href='/signin'
                    className='whitespace-nowrap my-auto ml-auto mr-auto md:mr-0'>
                    Login to reserve
                  </Button>
                )
              }
            />
          </article>
        )}
      </section>
    </>
  );
};
